
const Settings = () => {

    return(
        <p>Configurações</p>
    )
    
 }

 export default Settings;